import firebase from 'firebase/app';
import 'firebase/firestore';

var config = {
	apiKey: "AIzaSyDwTjul79rskU9yHYXTQHhGjflmFQnaYcg",
	authDomain: "todo-final-ddd.firebaseapp.com",
	databaseURL: "https://todo-final-ddd.firebaseio.com",
	projectId: "todo-final-ddd",
	storageBucket: "todo-final-ddd.appspot.com",
	messagingSenderId: "413716708327"
};

firebase.initializeApp(config);
export default firebase;